<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import Plane from "@/Components/Generics/Plane.vue";
import BreezeInput from "@/Components/Input.vue";
import BreezeLabel from "@/Components/Label.vue";
import MainPage from "@/Components/MainPage.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import App from "@/Layouts/App.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        MainPage,
        Plane,
        GenericButton,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
    },
    layout: App,
    props: {
        email: {
            type: String,
            required: true,
        },
        token: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                token: this.token,
                email: this.email,
                password: "",
                password_confirmation: "",
            }),
        };
    },
    methods: {
        submit(): void {
            this.form.post(this.route("password.update"), {
                onFinish: () => this.form.reset("password", "password_confirmation"),
            });
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('auth.password_reset')" :gap="false">
        <Plane class="reset-plane" :darker="true">
            <div class="flex flex--width flex--v flex--gap-20">
                <BreezeValidationErrors />

                <form class="full-width" @submit.prevent="submit">
                    <div class="flex flex--v flex--gap-20">
                        <div class="flex flex--v flex--gap-5">
                            <BreezeLabel for="email" :value="$trans('auth.email')" />
                            <BreezeInput id="email" v-model="form.email" type="email" required autofocus autocomplete="username" />
                        </div>

                        <div class="flex flex--v flex--gap-5">
                            <BreezeLabel for="password" :value="$trans('auth.password')" />
                            <BreezeInput id="password" v-model="form.password" type="password" required autocomplete="new-password" />
                        </div>

                        <div class="flex flex--v flex--gap-5">
                            <BreezeLabel for="password_confirmation" :value="$trans('auth.password_confirm')" />
                            <BreezeInput id="password_confirmation" v-model="form.password_confirmation" type="password" required autocomplete="new-password" />
                        </div>

                        <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                            <GenericButton class="reset-button" :title="$trans('auth.password_reset')" :disabled="form.processing" @click="submit" />
                        </div>
                    </div>
                </form>
            </div>
        </Plane>
    </MainPage>
</template>

<style lang="scss" scoped>
.reset-plane {
    max-width: rem(500);
    margin: 0 auto;

    .reset-button {
        height: rem(45);
        margin-top: rem(5);
    }

    .inertia-link {
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
